import { SpotHighlight as SpotHighlightComponent } from '@almbrand/spothighlight';
import { ctaGroupMargins, generateButtonArray } from 'utilities';

export interface SpotHighlightProps extends LocalId {
	contentId: number | string;
	backgroundColor?: BackgroundColor;
	image: Image;
	imagePosition: 'left' | 'right';
	textArea: string;
	buttons?: Button[];
	ctaMarginTop?: string;
	ctaMarginBottom?: string;
	bmetricId?: string;
}

export const SpotHighlight: React.FC<SpotHighlightProps> = ({
	contentId,
	backgroundColor,
	image,
	imagePosition,
	textArea,
	buttons,
	ctaMarginTop,
	ctaMarginBottom,
	useReadline,
	readlineId,
	bmetricId,
}) => {
	const { properties, url } = image ?? {};
	const { imageFocalPoint, altText } = properties;

	return (
		<SpotHighlightComponent
			id={useReadline && readlineId ? readlineId : contentId}
			className={bmetricId}
			backgroundColor={backgroundColor?.cssClass ?? 'bg-secondary'}
			image={{
				imageSrc: url,
				imageFocalPoint: { x: imageFocalPoint?.x, y: imageFocalPoint?.y },
				altText: altText,
				imageShape: 'default',
			}}
			imagePosition={imagePosition ?? 'left'}
			richText={{ description: textArea }}
			ctaGroup={generateButtonArray(buttons, ctaGroupMargins(ctaMarginTop, ctaMarginBottom))}
		/>
	);
};
